import {Injectable} from '@angular/core';
import { Params } from '@angular/router';
import { REMEMBER_ME, getLoginUrl } from '../model/domain/login-provider.model';

export const DefaultLocale = 'en';

@Injectable({
  providedIn: 'root'
})
export class LoginProviderService {

  constructor() { }

  handleLoginProviderHint(queryParams: Params): string | null {
    let loginProviderHint = queryParams.provider_hint;
    let provider_type = queryParams.provider_type;
    if (loginProviderHint && loginProviderHint !== '' && provider_type && provider_type !== '') {
        // Provider Hint is passed: We do not want to display the hosted pages, but redirect directly to the login provider.
        let social_url = getLoginUrl(queryParams.requestId, queryParams.provider_type, queryParams.provider_hint)
        if (queryParams.remember_me) {
            social_url = social_url + "?" + REMEMBER_ME + "=true";
        }
        if (social_url) {
           return social_url;
        }
    }
    return null;
  }

  /**
   * Returns the redirect URI to the social provider if only one social provider is configured, and the allowed_login_with is not set or empty.
   * Returns null if no automatic redirection should happen.
   * @param clientInfo 
   * @param requestId 
   * @returns 
   */
  getProviderRedirectURI(clientInfo, requestId: string): (string | null) {
    if (clientInfo.allow_login_with && clientInfo.allow_login_with.length > 0) {
      // No redirect
      return null;
    }
    // Check if only one element is given in any of these arrays:
    // login_providers, saml_providers, ad_providers
    let checkArr = [].concat(clientInfo.login_providers);
    checkArr = checkArr.concat(clientInfo.saml_providers);
    checkArr = checkArr.concat(clientInfo.ad_providers);
    checkArr = checkArr.concat(clientInfo.custom_providers);
    // Filter out all null & undefined values
    checkArr = checkArr.filter((element)=> element);
    if (checkArr.length !== 1) {
      return null;
    }
    let redirectUri = "";
    if (clientInfo.login_providers && clientInfo.login_providers.length > 0) {
      redirectUri = getLoginUrl(requestId, 'social', clientInfo.login_providers[0])
    } else if (clientInfo.saml_providers && clientInfo.saml_providers.length > 0) {
      redirectUri = getLoginUrl(requestId, 'saml', clientInfo.saml_providers[0].provider_name)
    } else if (clientInfo.ad_providers && clientInfo.ad_providers.length > 0) {
      redirectUri = getLoginUrl(requestId, 'ad', clientInfo.ad_providers[0].provider_name)
    } else if (clientInfo.custom_providers && clientInfo.custom_providers.length > 0) {
      redirectUri = getLoginUrl(requestId, 'custom', clientInfo.custom_providers[0].provider_name)
    }
    return redirectUri
  }
}

